<h1 id="title" class="title">Sign out</h1>

<nb-alert *ngIf="!!errorMessage" outline="danger" role="alert">
	<p class="alert-title"><b>{{ 'Errors.LogoutErrorMessage' | translation }}</b></p>
	<p>
		{{errorMessage}}
	</p>
</nb-alert>
